import { render, staticRenderFns } from "./MatchCenter.vue?vue&type=template&id=923e601e&scoped=true&"
import script from "./MatchCenter.vue?vue&type=script&lang=js&"
export * from "./MatchCenter.vue?vue&type=script&lang=js&"
import style0 from "./MatchCenter.vue?vue&type=style&index=0&id=923e601e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923e601e",
  null
  
)

export default component.exports